// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './ColorDiamondColorFilter.style';
import Slider from "react-slick";
import "react-slick/dist/react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FilterLabel from 'Component/FilterLabel';
import { colordiamond_labcolor, colordiamond_naturalcolor } from 'Src/Value/ColorDiamond_color';
import { generateQuery, getQueryParam, removeQueryParamWithoutHistory } from '@scandipwa/scandipwa/src/util/Url';
import history from '@scandipwa/scandipwa/src/util/History';

export class ColorDiamondColorFilter extends PureComponent {
    static propTypes = {
        renderGetDiamond: this.propTypes,
        selectedOrigin: this.propTypes
    };

    typesettings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoPlay: false,
        responsive: [
            {
                breakpoint: 1299,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 810,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 7,
                }
            },
            {
                breakpoint: 667,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
        ]
    };

    state = {
        selectedColor: ""
    }

    componentDidMount() {
        const location = window?.location;

        const colorfilter = getQueryParam("fancy_color_dominant_color", location || '');

        if (colorfilter) {
            this.setState({
                selectedColor: colorfilter
            });
        }
    }

    selectColor = (value) => {
        const { renderGetDiamond } = this.props;
        const { selectedColor } = this.state;

        if (selectedColor === value.code) {
            this.setState({
                selectedColor: ""
            });

            removeQueryParamWithoutHistory('fancy_color_dominant_color', history, window.location);
        } else {
            this.setState({
                selectedColor: value.code
            });

            const query = generateQuery({ fancy_color_dominant_color: `${value.code}` }, window?.location, history);
            history.push(query);
        }

        renderGetDiamond();
    }

    renderColorFilter = (value) => {
        const { selectedColor } = this.state;

        return (
            <div
                className={(selectedColor === value?.code ? "ColorDiamondColorFilter-Color_isSelected " : "") + 'ColorDiamondColorFilter-Color'}
                onClick={() => this.selectColor(value)}
                aria-label={value.code}
            >
                <div className='ColorDiamondColorFilter-ColorIcon'>
                    <img src={value?.icon} />
                </div>
                <span className='ColorDiamondColorFilter-Label'>{value?.label}</span>
            </div>
        )
    }

    renderColor = () => {
        const { selectedOrigin } = this.props;

        if (selectedOrigin === "12") {
            return (
                <Slider {...this.typesettings}>
                    {
                        colordiamond_labcolor?.map((value, index) => (
                            <div key={index}>
                                {this.renderColorFilter(value)}
                            </div>
                        ))
                    }
                </Slider>
            )
        }

        return (
            <Slider {...this.typesettings}>
                {
                    colordiamond_naturalcolor?.map((value, index) => (
                        <div key={index}>
                            {this.renderColorFilter(value)}
                        </div>
                    ))
                }
            </Slider>
        )
    }

    render() {
        return (
            <div className="ColorDiamondColorFilter">
                <FilterLabel label={"Color"}>
                    {this.renderColor()}
                </FilterLabel>
            </div>
        );
    }
}

export default ColorDiamondColorFilter;
